import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { isMixedCabin } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { MixedCabinDisclaimerProps } from "@tenant/flights";
import { InfoBanner, InfoBannerSeverity } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./MixedCabinDisclaimer.module.scss";

const COMPONENT_KEY = CoreFlightsComponent.MixedCabinDisclaimer;

export const MixedCabinDisclaimer = ({
  fareSlice,
  className,
}: MixedCabinDisclaimerProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  if (!isMixedCabin(fareSlice)) {
    return null;
  }

  return (
    <InfoBanner
      className={clsx(block, className)}
      severity={InfoBannerSeverity.INFO}
      icon={IconNameEnum.infoFilled}
    >
      <p className={cn("title")}>{t("mixedCabin.title")}</p>
      <p className={cn("description")}>{t("mixedCabin.disclaimer")}</p>
    </InfoBanner>
  );
};
